import React, {useState} from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {TextareaAutosize} from "@material-ui/core";
import {makeStyles, withStyles} from "@material-ui/core/styles";

// import { light } from "@material-ui/core/styles/createPalette";
// import {input} from "../faux_data/augment_new";
import {
  Selection,
  LabelContainer,
  Label
} from "../styles/selection_group_styles";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

const BlueRadio = withStyles({
  root: {
    color: "#d3d3d3",
    "&$checked": {
      color: "#00A5CF"
    }
  },
  checked: {}
})((props) => <Radio color="default" {...props} />);



const SelectionRadioGroup = (props) => {
  const [value, setValue] = useState(null);
  //send thru a function coming from stepper to pull data on submit/onchange
  const handleChange = (event) => {
    if (props.activeStep != 0) {
      return;
    }
    setValue(event.target.value);
    props.setInput(event.target.value);
  };
  // const colored_data = addColor(input, "label");
  return (
    <FormControl component="fieldset">
      <RadioGroup
        aria-label="input sentence options"
        name="input"
        value={value}
        onChange={handleChange}
      >
        {props.data &&
          props.data.map((item, idx) => (
            <Selection key={idx}>
              <FormControlLabel
                id={idx}
                value={item.original}
                control={<BlueRadio />}
                label={item.original}
              />
              <LabelContainer>
                <ArrowRightAltIcon
                  style={{verticalAlign: "-14px", fontSize: "36"}}
                />
                <Label color={item.color} > {item.label} </Label>
              </LabelContainer>
            </Selection>
          ))}
      </RadioGroup>
    </FormControl>
  );
};
// {items}
export default SelectionRadioGroup;
